import { Trans, useLingui } from '@lingui/react/macro';

import { FilterCheckboxItem } from '@/design_system/Filters/FiltersMenu/FilterCheckboxItem';
import {
  FilterItemNoResults,
  FiltersMenu,
  FiltersSubMenu,
} from '@/design_system/Filters/FiltersMenu/FiltersMenu';
import { FilterTag } from '@/design_system/Filters/FiltersMenu/FilterTag';
import IconPerson from '@/icons/User.svg';
import { REQUESTOR_TYPES } from '@/models/request';

import { useFilters } from '../FiltersState';
import { useApplicantOptions } from '../utils';

export const FiltersApplicant = ({ tag }: { tag?: boolean }) => {
  const { t, i18n } = useLingui();

  const {
    requestorTypes: { requestorTypes, setRequestorTypes },
  } = useFilters();

  const applicantOptions = useApplicantOptions();

  const options =
    applicantOptions.length > 0 ? (
      applicantOptions.map(({ id, label }) => (
        <FilterCheckboxItem
          key={id}
          checked={requestorTypes.includes(id)}
          onChange={(checked) => {
            if (checked) {
              setRequestorTypes([...requestorTypes, id]);
            } else {
              setRequestorTypes(requestorTypes.filter((type) => type !== id));
            }
          }}
        >
          {i18n._(label)}
        </FilterCheckboxItem>
      ))
    ) : (
      <FilterItemNoResults />
    );

  if (tag) {
    if (requestorTypes.length === 0) {
      return null;
    }

    return (
      <FiltersMenu
        button={
          <FilterTag
            label={t({ id: 'requests.filters.applicant.label', message: 'Applicant type' })}
            value={
              requestorTypes.length === 1 ? (
                i18n._(REQUESTOR_TYPES.find((type) => type.id === requestorTypes[0])!.label)
              ) : (
                <Trans id="requests.filters.applicant.multiple">
                  {requestorTypes.length} types
                </Trans>
              )
            }
            tooltip={
              requestorTypes.length > 1
                ? requestorTypes
                    .map((type) => i18n._(REQUESTOR_TYPES.find((t) => t.id === type)!.label))
                    .join(', ')
                : undefined
            }
            onClear={() => setRequestorTypes([])}
          />
        }
      >
        {options}
      </FiltersMenu>
    );
  }

  return (
    <FiltersSubMenu
      icon={<IconPerson />}
      label={t({ id: 'requests.filters.applicant.label', message: 'Applicant type' })}
    >
      {options}
    </FiltersSubMenu>
  );
};
